import { fromListStoreGroupsQueryToStoreGroup } from "./adapters.js";
import { GET_LIST_STORE_GROUPS } from "./queries.js";
async function getListStoreGroups(apolloClient, locale) {
  try {
    const { data, error } = await apolloClient.query({
      query: GET_LIST_STORE_GROUPS,
      ...locale ? {
        context: {
          forwardHeaders: {
            "Accept-Language": locale
          }
        }
      } : {}
    });
    if (error) {
      console.error(error);
      throw new Error(error.message);
    }
    return fromListStoreGroupsQueryToStoreGroup(data?.listStoreGroups);
  } catch (e) {
    console.error(`Failed to query listStoreGroups: ${e}`);
    return {};
  }
}
export {
  getListStoreGroups
};
//# sourceMappingURL=data.js.map
